<div class="container team-content px-md-0">
  <div class="row">
    <div class="col-md-7">
      <app-promo-banner style="margin-bottom: 16px"></app-promo-banner>
      <div class="row">
        <div class="col-md-12 team-info-subnav">
          <a mat-select-button class="mat-select-button" routerLinkActive="selected"
             href="/info/funktionaere" routerLink="/info/funktionaere">Funktionäre</a>
          <a mat-select-button class="mat-select-button" routerLinkActive="selected"
             href="/info/stadion" routerLink="/info/stadion">Stadion</a>
          <a mat-select-button class="mat-select-button" routerLinkActive="selected"
             href="/info/kontakt" routerLink="/info/kontakt">Kontakt</a>
        </div>
        <div class="col-md-12">
          <router-outlet></router-outlet>
        </div>
      </div>

    </div>
    <div class="col-md-5 team-sidebar">
      <div class="row">
        <lib-ad class="col-12 mt-2"></lib-ad>
      </div>
    </div>
  </div>
</div>
